module.exports = __webpack_public_path__ + "70c5ccbe15fe4300d80ce825a98e541b.MP3";